<template>
  <div>
    <Header>Event List</Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="mt-3 text-left p-3 bg-gray-100 rounded-md !shadow">
        <SearchForm
          v-model="search.query"
          @clear="clearAllFilters"/>
          <div class="flex flex-row justify-between">
            <div class="flex gap-4 flex-wrap pb-3">
              <div class="flex flex-row">
                <div class="rounded-l-md shadow-sm p-2">
                  Start
                </div>
                <Input
                  label="Start"
                  ref="startDateInput"
                  class="rounded-md shadow-sm"
                  type="date"
                  v-model="startDate"
                />
              </div>
              <div class="flex flex-row">
                <div class="rounded-l-md shadow-sm p-2">
                  End
                </div>
                <Input
                  label="End"
                  ref="endDateInput"
                  class="rounded-md shadow-sm"
                  type="date"
                  v-model="endDate"
                />
              </div>
              <div class="flex flex-row">
                <Button
                  class="bg-white rounded-md text-gray-600 font-normal shadow-sm h-10 p-2 hover:!bg-gray-50"
                  :size="'sm'"
                  @click="clearDateRange()">
                  Clear
                </Button>
              </div>
            </div>
            <a ref="download">
              <Button
                class="bg-white rounded-md text-gray-600 font-normal shadow-sm h-10 p-2 hover:!bg-gray-50"
                :size="'sm'"
                @click="exportToCSV()">
                Export to CSV
              </Button>
            </a>
          </div>
        <div class="flex gap-4 flex-wrap justify-between">
          <MultiCheckboxField
            v-model="selectedFilter"
            :options="fields.map((x)=>x.label).slice(0,-1)">

          </MultiCheckboxField>
          <div class="flex">
            <label class="mr-2 pr-2 mt-2">
              <input type="checkbox"
                v-model="showPastEvents">
              Show past events
            </label>
            <Button v-if="canSubmitNew"
              :color="'blue'"
              :size="'sm'"
              class="rounded-md !shadow m-1"
              @click="toCalendarForm()">
              New event
            </Button>
          </div>
        </div>
        <p class="text-sm text-red-600 -mb-2">{{ searchWarning }}</p>
      </div>
      <div class="mt-6 space-y-2 pb-6">
        <TableComponent>
          <template #columns>
            <th
              v-for="field in fields"
              :key="field.key">
              <SortTable
                :name="field.key"
                :selectedSort="selectedSort"
                @setSelectedSort="selectedSort = $event">
                {{ field.label }}
              </SortTable>
            </th>
          </template>
          <template #rows v-if="!loading">
            <EventListItem 
              v-for="(event, index) in calEventList"
              :key="index"
              :index="index"
              :event=event
              @onEdit="onEdit(event)"
              @onDelete="onDelete(event)"
              :selected="event.id == selected"
              @changeSelected="selected = $event"
              >
            </EventListItem>
          </template>
        </TableComponent>
        <Spinner
          v-if="loading"
          message="Loading Events"
          :size="10"
        />
      </div>
    </Main>
    <Modal
      ref="delete-modal"
      size="sm"
      anchor="centered"
      :showClose="true"
      :onSuccess="() => deleteItem(calEventList.find(el => el.id === deleteId)?.id)"
    >
      <template #title>Delete this event?</template>
      <template #content>
        <table>
          <tr>
            <th>District</th>
            <th>Date</th>
            <th>Event Type</th>
          </tr>
          <tr>
            <td>{{ calEventList.find(el => el.id === deleteId)?.district?.label }}</td>
            <td>{{ calEventList.find(el => el.id === deleteId)?.event_date }}</td>
            <td>{{ typeFormatter(calEventList.find(el => el.id === deleteId)?.event_type) }}</td>
          </tr>
        </table>
        <!-- <div class="flex flex-col">
          <div>
            From district: {{ calEventList.find(el => el.id === deleteId).district.label }}
          </div>
          <div>
            For date: {{ calEventList.find(el => el.id === deleteId).event_date }}
          </div>
        </div> -->
      </template>
      <template #footer="slotProps">
        <button
          type="button"
          class="rounded-md font-medium text-red-900 bg-red-200 px-3 py-2 hover:bg-red-300 transition-colors shadow-sm"
          @click="() => slotProps.closeModal(true)"
        >
          Delete
        </button>
      </template>
    </Modal>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>

<script>
import Header from '../../components/Header.vue'
import Main from '../../components/Main.vue'
import SearchForm from '../../components/Search/SearchForm.vue'
import Table from '../../components/Table.vue'
import SortTable from '../../components/SortTable.vue'
import Spinner from '../../components/Spinner.vue'
import Modal from '../../components/Modal.vue'
import DropdownLists from '../../components/DropdownLists.json'
import MultiCheckboxField from '../../components/formComponents/MultiCheckboxField.vue'
import Button from '../../components/Button.vue'
import Input from '../../components/Input.vue'

import EventListItem from './EventListItem.vue'
import FieldsDef from './FieldsDef.js'

import cloneDeep from 'clone-deep'

import user from '../../services/user/user.js'
// import view from '../../services/user/view.js'

import eventListService from '../../services/pages/eventList.js'


export default {
  components: {
    Header,
    Main,
    SearchForm,
    TableComponent: Table,
    SortTable,
    EventListItem,
    MultiCheckboxField,
    Spinner,
    Modal,
    Button,
    Input
  },
  name: 'calEventList',
  data() {
    return {
      view: undefined,
      user: {},
      loading: false,
      allDistricts: false,
      districtList: [],
      calEventList: [],
      unsortedEventList: [],
      fields: FieldsDef,
      selectedFilter: [],
      filter: null,
      selected: -1,
      deleteId: -1,
      canSubmitNew: true,
      showPastEvents: false,
      searchWarning: '',
      search: {
        query: ''
      },
      selectedSort: {
        name: '',
        descending: false
      },
      startDate: '',
      endDate: '',
      gradeList: DropdownLists.gradeList,
      eventTypes: DropdownLists.eventList
    }
  },
  methods: {
    exportToCSV() {
      const headers = ['DistrictNumber', 'EventType', 'EventTime', 'FirstDate', 'LastDate', 'LowGrade', 'HighGrade','Building']
      let rows = []
      for(let event of this.calEventList) {
        let district
        if (event.district) {
          district = event.district.value
          const index = district.indexOf('-')
          district = district.slice(0, index)

          if (event.building) {
            district += '_' + event.building.code
          }
          else {
            district += '_' + event.district.display
          }
        }
        else {
          district = 'null'
        }
        let building = event.building ? event.building.name : event.district.name
        let lowGrade = this.gradeList[event.low_grade]
        let highGrade = this.gradeList[event.high_grade]
        if (lowGrade && lowGrade[0] == '0' && lowGrade[1] != '.') {
          lowGrade = Number(lowGrade)
        }
        if (highGrade && highGrade[0] == '0' && highGrade[1] != '.') {
          highGrade = Number(highGrade)
        }
        if (lowGrade == 'Pre-K') {
          lowGrade = 0
        }
        if (lowGrade == 'K') {
          lowGrade = 0.5
        }
        if (highGrade == 'Pre-K') {
          highGrade = 0
        }
        if (highGrade == 'K') {
          highGrade = 0.5
        }
        if (lowGrade == '12+') {
          lowGrade = 13
        }
        if (highGrade == '12+') {
          highGrade = 13
        }
        rows.push([district, event.event_type, event.time, event.event_date, event.event_date, lowGrade, highGrade, building])
      }
      rows.unshift(headers)
      let content = ''
      rows.forEach(row => {
        content += row.join(',') + '\n'
      })      
      const blob = new Blob([content], {type: 'text/csv'})
      const url = URL.createObjectURL(blob)
      let anchor = this.$refs['download']
      anchor.href = url
      const timeStamp = new Date().toISOString()
      anchor.download = 'events_' + timeStamp + '.csv'
    },
    clearDateRange() {
      this.startDate = ''
      this.endDate = ''
    },
    sortDateRange() {
      let sortedList = []
      for (let event of this.calEventList) {
        let eventDate = new Date(event.event_date)
        eventDate.setHours(0, 0, 0, 0)
        if (this.startDate != '' && this.endDate == '') {
          if (new Date(this.startDate) <= eventDate) {
            sortedList.push(event)
          }
        }
        else if (this.endDate != '' && this.startDate == '') {
          if (new Date(this.endDate) >= eventDate) {
            sortedList.push(event)
          }
        }
        else if (this.endDate != '' && this.startDate != '') {
          if (new Date(this.startDate) <= eventDate && new Date(this.endDate) >= eventDate) {
            sortedList.push(event)
          }
        }
        else {
          this.calEventList = this.unsortedEventList
          this.sortPastEvents()
          return
        }
      }
      this.calEventList = cloneDeep(sortedList)
      // this.sortPastEvents()
    },
    sortPastEvents(currList = this.unsortedEventList) {
      if (!this.showPastEvents) {
        let upcomingList = []
        let today = new Date()
        today.setHours(0, 0, 0, 0)
        for (let event of this.calEventList) {
          let temp = new Date(event.event_date)
          let date = temp.getDate() + 1
          temp.setDate(date)
          temp.setHours(0,0,0,0)
          if (temp >= today) {
            upcomingList.push(event)
          }
          this.calEventList = upcomingList
        }
      }
      else {
        this.calEventList = cloneDeep(currList)
      }
    },
    toCalendarForm() {
      this.$router.push({ name: 'CalendarForm' })
    },
    typeFormatter(value) {
      return value.includes('undefined') ? '' : DropdownLists.eventList[value]
    },
    gradeFormatter (lowGrade, highGrade) {
      let low = DropdownLists.gradeList[lowGrade] ? DropdownLists.gradeList[lowGrade] : 'Pre-K'
      let high = DropdownLists.gradeList[highGrade] ? DropdownLists.gradeList[highGrade] : '12+'
      return low + ' - ' + high
    },
    formatTime(initTime) {
      var HH = initTime.substring(0, 2)
      var MM = initTime.substring(3, 5)
      let ampm = "AM"
      if (Number(HH) > 12) {
        HH = Number(HH) - 12
        ampm = "PM"
      }
      return HH + ':' + MM + ' ' + ampm  
    },
    setDefaultSort() {
      this.calEventList.sort((a, b) => {
        return new Date(a['event_date']) - new Date(b['event_date'])
      })
    },
    sort(sortObj) {
      let param = sortObj.name
      let descending = sortObj.descending
      switch (param) {
        case 'id':
        case 'low_grade':
          this.calEventList.sort((a, b) => {
            if (descending) {
              return b[param] - a[param]
            }
            else {
              return a[param] - b[param]
            }
          })
          break
        case 'event_date':
          this.calEventList.sort((a, b) => {
            if (descending) {
              return new Date(b[param]) - new Date(a[param])
            }
            else{
              return new Date(a[param]) - new Date(b[param])
            }
          })
          break
        case 'district':
          this.calEventList.sort((a, b) => {
            if (a[param].label.toUpperCase() < b[param].label.toUpperCase()) {
              return descending ? 1 : -1
            }
            if (a[param].label.toUpperCase() > b[param].label.toUpperCase()) {
              return descending ? -1 : 1
            }
          })
          break
        case 'building':
          this.calEventList.sort((a, b) => {
            if (a[param] == undefined || a[param] == '') {
              return 1
            }
            if (b[param] == undefined || b[param] == '') {
              return -1
            }
            if (a[param].name.toUpperCase() < b[param].name.toUpperCase()) {
              return descending ? 1 : -1
            }
            if (a[param].name.toUpperCase() > b[param].name.toUpperCase()) {
              return descending ? -1 : 1
            }
            return 0
          })
          break
        case '':
          this.calEventList = cloneDeep(this.unsortedEventList)
          this.sortPastEvents()
          break
        default:
          this.calEventList.sort((a, b) => {
            if (a[param] == undefined || a[param] == '') {
              return 1
            }
            if (b[param] == undefined || b[param] == '') {
              return -1
            }
            if (a[param].toUpperCase() < b[param].toUpperCase()) {
              return descending ? 1 : -1
            }
            if (a[param].toUpperCase() > b[param].toUpperCase()) {
              return descending ? -1 : 1
            }
            return 0
          })
      }
    },
    setSearch(search) {
      if (search == '') {
        this.calEventList = cloneDeep(this.unsortedEventList)
        this.sortPastEvents()
        return
      }
      if (this.selectedFilter.length == 0) {
        this.searchWarning = 'Please select a search filter'
        return
      }
      else {
        this.searchWarning = ''
      }
      let searchList = []
      for (const field of this.fields) {
        if (this.selectedFilter.includes(field.label)) {
          for (const event of this.calEventList) {
            for (const [k,v] of Object.entries(event)) {
              if (k == field.key) {
                if (field.key == 'building' && v) {
                  if (v != null && (v['name'].toString().toUpperCase().includes(search.toUpperCase()) 
                    || v['code'].toString().toUpperCase().includes(search.toUpperCase()))) {
                    searchList.push(event)
                  }
                }
                else if (field.key == 'district' && v) {
                  if (v['label'].toString().toUpperCase().includes(search.toUpperCase())) {
                    searchList.push(event)
                  }
                }
                else if (field.key == 'low_grade' && v) {
                  if (this.gradeFormatter(event['low_grade'], event['high_grade']).toUpperCase().includes(search.toString().toUpperCase())) {
                    searchList.push(event)
                  }
                }
                else if (field.key == 'event_type' && v) {
                  if (this.eventTypes[v].toString().toUpperCase().includes(search.toUpperCase())) {
                    searchList.push(event)
                  }
                }
                else if (field.key == 'time' && v) {
                  if (this.formatTime(v).toUpperCase().includes(search.toUpperCase())) {
                    searchList.push(event)
                  }
                }
                else if (v != null && v.toString().includes(search.toUpperCase())) {
                  searchList.push(event)
                }
              }
            }
          }
        }
      }
      this.calEventList = searchList
      this.sortPastEvents(this.calEventList)
    },
    clearAllFilters() {
      this.startDate = ''
      this.endDate = ''
      this.searchWarning = ''
      this.selectedFilter = []
      this.setSearch('')
    },
    onDelete(item) {
      this.deleteId = item.id
      this.$refs['delete-modal'].openModal()
    },
    async deleteItem(id) {
      let deleteResponse = await eventListService.deleteCalendarEvent(id)
      if (deleteResponse.status != 200) {
        this.$refs['delete-modal'].closeModal()
        throw new Error(deleteResponse.statusText)
      } else {
        this.updateEvents()
        this.$refs['delete-modal'].closeModal()
      }
      this.$router.go()
    },
    onEdit(value) {
      this.$router.push({
        name: 'CalendarForm',
        params: { filledevent: value },
      })
    },
    // async getDistricts() {
    //   let result = await districtService.getAllDistricts()
    //   for (const district of result.data) {
    //     let districtObj = {
    //       value: district.code,
    //       label: `${district.code}: ${district.name}`,
    //       display: district.display_code,
    //       name: district.name,
    //     }
    //     this.districtList.push(districtObj)
    //   } 
    // },
    async updateEvents() {
      this.user = await user.get()
      if (this.user.can('submit_calendar_event') && this.user.can('select_district')) {
        this.allDistricts = true
      }
      else {
        this.allDistricts = false
      }

      let eventResponse
      this.loading = true
      eventResponse = await eventListService.getAllEvents()
      if (eventResponse.status !== 200) {
        throw new Error(eventResponse.statusText)
      }
      
      let events = eventResponse.data
      for(let calEvent of events){
        if(calEvent.district){
          let districtObj = {
            value: calEvent.district.code,
            label: `${calEvent.district.code}: ${calEvent.district.name}`,
            display: calEvent.district.display_code,
            name: calEvent.district.name,
          }
          calEvent.district = districtObj
        }
      }
     
      this.calEventList = events
      this.setDefaultSort()
      this.unsortedEventList = cloneDeep(this.calEventList)
      this.sortPastEvents()
      this.loading = false
    },
    checkUserCanViewPage() {
      if(!this.user.can('view_event_list')) {
        this.$router.push({
          name: 'Home'
        })
        return true
      }
    },
  },
  async mounted() {
    this.updateEvents()
    this.user = await user.get()
    this.canSubmitNew = this.user.can('view_calendar_event')
  },
  async created() {
    this.user = await user.get()
    if (this.checkUserCanViewPage()) {
      return
    }
  },
  watch: {
    selectedSort: function (value) {
      this.sort(value)
    },
    'search.query': function (value) {
      this.setSearch(value)
    },
    showPastEvents: function () {
      this.sortPastEvents()
    },
    startDate: function () {
      this.sortDateRange()
    },
    endDate: function () {
      this.sortDateRange()
    },
  }
}
</script>

<style>
#calEventList {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
}
table #main-table .flip-list-move {
  transition: transform 0.5s;
}
</style>
